import CustomButton from "@/components/CustomButton";
import { usePrintLTIPTranchDetail } from "@/hooks/usePrintLTIPTranchDetail";
import { useAppSelector } from "@/hooks/useAppSelector";
import { AxiosError } from "axios";
import { useRef } from "react";
import { toast } from "react-toastify";
import { LTIPType } from "@/types/enums";
import { getHouseholdPrintFileName } from "@/helper/helper";
import { IS_PRODUCTION } from "@/constants/constants";

type Props = {
  externalCode?: string;
  detailCode?: string;
  trancheName?: string;
};

export default function PrintSARDetailButton({ externalCode, detailCode, trancheName }: Props) {
  const { isModified } = useAppSelector((state) => state.npv);
  const {
    household,
    header: { isError },
  } = useAppSelector((state) => state.household);

  const divRef = useRef<HTMLDivElement>(null);
  const { mutateAsync: downloadAsync, error: printErrorMsg } = usePrintLTIPTranchDetail();

  const fileName = getHouseholdPrintFileName({
    clientCode: household?.clientCode,
    tabName: `SAR ${trancheName}`,
  });

  const toastMessages = {
    pending: "Downloading SAR tranche...",
    success: "SAR tranche downloaded!",
    error:
      printErrorMsg instanceof AxiosError
        ? printErrorMsg.message
        : "Downloading SAR tranche failed",
  };

  if (IS_PRODUCTION || isError) return null;

  return (
    <div className="relative" ref={divRef}>
      <CustomButton
        className="print:hidden"
        disabled={isModified}
        text={"Print to PDF"}
        onClickHandler={() => {
          toast.promise(
            downloadAsync({
              household: household?.externalCode,
              type: LTIPType.SARs,
              externalCode,
              detailCode,
              fileName,
            }),
            toastMessages
          );
        }}
      />
    </div>
  );
}
